import React from 'react';
import { useAppSelector } from '../../../../../../store/hooks';
import { DAILY_MESSAGE_LIMIT } from '../../../../../../store/chat/slice';
import { parseISO, format, addDays, formatDistanceToNow } from 'date-fns';
import { Text } from '../../../../../../components/Typography';

const MessageLimitIndicator: React.FC = () => {
  const { dailyMessageCount, resetTime } = useAppSelector((state) => state.chat);
  const hasReachedMessageLimit = dailyMessageCount >= DAILY_MESSAGE_LIMIT;

  const getResetTimeDisplay = () => {
    if (resetTime) {
      const resetDate = parseISO(resetTime);
      return {
        time: format(resetDate, 'h:mm a'),
        relative: formatDistanceToNow(resetDate, { addSuffix: true }),
      };
    }

    const tomorrow = addDays(new Date(), 1);
    return {
      time: format(tomorrow, 'h:mm a'),
      relative: '24 hours from now',
    };
  };

  if (!hasReachedMessageLimit) {
    return null;
  }

  return (
    <div>
      <Text size="base">
        You've reached your daily message limit of {DAILY_MESSAGE_LIMIT} messages. Limit will reset{' '}
        {getResetTimeDisplay().relative} ({getResetTimeDisplay().time}).
      </Text>
    </div>
  );
};

export default MessageLimitIndicator;
